import * as React from 'react'
import {
    Route,
    Switch,
    useRouteMatch,
} from 'react-router-dom';

import { NamespacesTable } from '@app/SecretManager/SecretsExplorer/view/NamespacesTable';
import { NamespacePage } from '@app/SecretManager/SecretsExplorer/view/NamespacePage';
import { ApplicationPage } from '@app/SecretManager/SecretsExplorer/view/ApplicationPage';
import { ContainerPage } from '@app/SecretManager/SecretsExplorer/view/ContainerPage';
import { SecretDetailsPage } from '@app/SecretManager/SecretsExplorer/view/SecretDetailsPage';
import { FileDetailsPage } from './FileDetailsPage';
import { ClusterSelection } from '../../../SecretManager/common/ClusterSelection';
import { useSecretManagerNamespaces } from '../../hooks/useSecretManagerData';


const SecretManager: React.FunctionComponent = () => {
    const { path } = useRouteMatch();

    const { data, isLoading } = useSecretManagerNamespaces();
    const namespaces = data?.namespaces ?? [];
    const keyvaults = data?.keyvaults ?? {};

    if (isLoading) {
        return (
            <section className="dx-page-section">
                <div className="dx-empty-state">
                    <div className="dx-empty-state__icon"><div className="dx-spinner" /></div>
                    <h4 className="dx-empty-state__title">Loading</h4>
                </div>
            </section>
        )
    }

    return (
        <>
            <Switch>
                <Route path={`${path}`} exact>
                    <NamespacesTable namespaces={namespaces} clusterSelector={<ClusterSelection />} />
                </Route>
                <Route path={`${path}/:namespace_name`} exact>
                    <ClusterSelection />
                    <NamespacePage namespaces={namespaces} root={path} />
                </Route>
                <Route path={`${path}/:namespace_name/:application_name`} exact>
                    <ClusterSelection />
                    <ApplicationPage namespaces={namespaces} root={path} />
                </Route>
                <Route path={`${path}/:namespace_name/:application_name/:container_name`} exact>
                    <ClusterSelection />
                    <ContainerPage namespaces={namespaces} root={path} />
                </Route>
                <Route path={`${path}/:namespace_name/:application_name/:container_name/variable/:secret_name`} exact>
                    <ClusterSelection />
                    <SecretDetailsPage namespaces={namespaces} keyvaults={keyvaults} root={path} />
                </Route>
                <Route path={`${path}/:namespace_name/:application_name/:container_name/file/:file_path`} exact>
                    <ClusterSelection />
                    <FileDetailsPage namespaces={namespaces} keyvaults={keyvaults} root={path} />
                </Route>
            </Switch>
        </>
    );
};

export { SecretManager };
